module.exports = __webpack_public_path__ + "img/act_pro_img3s_03.914a155a.png";